<template>
    <div class="lawsuit_index no-trans" v-loading="loading">
        <div class="lawsuit_index_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/online">法律咨询</router-link> > <span class="span2" aria-current="page">{{$route.query.title_num==1?'简单咨询':'详细咨询'}}</span>
             </div>
             <div class="info_box">
                <div class="info_title">{{$route.query.title_num==1?'简单咨询':'详细咨询'}}</div>
                <div class="info_flex">
                    <div class="lefts">
                        <div class="items" v-for="(item,index) in type_list" :key="index" :class="{'items_ac':type_ac>=index}">
                            <div class="item_flex">
                                <span class="span1"> {{ index+1 }}</span>
                                <span class="span2"> {{ item.title }}</span>
                            </div>
                            <div class="borders" v-if="index<(type_list.length-1)"></div>
                        </div>
                    </div>
                    <div class="rights">
                         <lawsuit_1 ref="lawsuit_1" v-show="type_ac==0" @handle_end1="handle_end1"></lawsuit_1>
                         <lawsuit_2 ref="lawsuit_2" v-show="type_ac==1" @handle_end2="handle_end2" @handle_shang2="handle_shang2"></lawsuit_2>
                         <lawsuit_3 ref="lawsuit_3" v-show="type_ac==2" @handle_end3="handle_end3"></lawsuit_3>
                    </div>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 
import lawsuit_1 from '@/components/legal_advice/lawsuit/lawsuit_1.vue'
import lawsuit_2 from '@/components/legal_advice/lawsuit/lawsuit_2.vue'
import lawsuit_3 from '@/components/legal_advice/lawsuit/lawsuit_3.vue'


export default {
    components: {
        lawsuit_1,
        lawsuit_2,
        lawsuit_3,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            order_id:0,
            type_ac:0,
            type_list:[
                {
                    title:'案件类型',
                },
                {
                    title:'当事人信息',
                },
                {
                    title:'材料上传',
                }
            ]
        }
    },
    computed: {
       
    },
    watch: {
        $route(to, from) {
            if(this.$route.query.type_num){
                this.type_ac=this.$route.query.type_num
            }
        },
    },
    created() {
        if(this.$route.query.type_num){
            this.type_ac=this.$route.query.type_num
        }
    },
    methods: {
      
        handle_end1(obj){
            console.log('回馈的值',obj)
            this.order_id=obj.order_id
            // this.type_ac=1
            this.$router.replace({
                path:'/lawsuit_index',
                query:{
                    ...this.$route.query,
                    order_id:this.order_id,
                    type_num:1
                }
            })
        },
        handle_end2(obj){
            console.log('回馈的值',obj)
            this.type_ac=2
            this.$router.replace({
                path:'/lawsuit_index',
                query:{
                    ...this.$route.query,
                   
                    type_num:2
                }
            })
        },
        handle_shang2(){
            this.type_ac=0
        },
        handle_end3(obj){
            console.log('回馈的值',obj)
            this.type_ac=3
        },



    },

}
</script>
<style scoped lang="less">
.lawsuit_index{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .lawsuit_index_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .info_box{
            width: 1440px;
            // height: 784px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding: 0 77px;
            padding-bottom: 50px;
            .info_title{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 28px;
                color: #333333;
                text-align: center;
                padding: 40px 0;
                border-bottom: 1px solid #E0E3E3;
            }
            .info_flex{
                display: flex;
                .lefts{
                    width: 270px;
                    height: 590px;
                    border-right: 1px solid #E0E3E3;
                    padding-top: 40px;
                    flex-shrink: 0;
                    .items{
                        width: 229px;
                        .item_flex{
                            width: 229px;
                            height: 48px;
                            background: #FFFFFF;
                            border-radius: 24px 24px 24px 24px;
                            border: 1px solid #DDDDDD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .span1{
                                font-family: Montserrat, Montserrat;
                                font-weight: 500;
                                font-size: 36px;
                                color: #B8C4D1;
                            }
                            .span2{
                                width: 100px;
                                text-align: left;
                                line-height: 48px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #B8C4D1;
                                padding-left: 11px;
                            }
                        }
                        .borders{
                            width: 0px;
                            height: 32px;
                            border: 1px solid #DDDDDD;
                            margin: 17px auto ;
                        }
                       
                    }
                    .items_ac{
                        .item_flex{

                            background: #377CFD;
                            border: 1px solid #377CFD;
                            .span1{
                                color: #FFFFFF;
                            }
                            .span2{
                                color: #FFFFFF;
                            }
                        }
                    }
                }
                .rights{
                    flex: 1;
                }   
            }
        }
        
        
    }
}

</style>
<style scoped lang="less">
@import "../../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .lawsuit_index.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .title_box .span1 {
        margin-right: 10px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .title_box .span2 {
        margin-left: 10px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .title_box img {
        margin-right: 10px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        padding-bottom: 16px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_title {
        font-size: 24px;
        padding: 16px 0;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding-top: 16px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts .items .item_flex {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 44px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts .items .item_flex .span1 {
        font-size: 24px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts .items .item_flex .span2 {
        width: 100px;
        line-height: 1.6;
        font-size: 16px;
        padding-left: 11px;
    }
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex .lefts .items .borders {
        width: 0px;
        height: 32px;
        margin: 16px auto;
    }
}

@media (max-width: 1024px) {
    .lawsuit_index.no-trans .lawsuit_index_box .info_box .info_flex { .mobile-stepper(); }
}
</style>
